import React from 'react'
import * as d3 from "d3";
import { getImages } from '../const'
import FullWidthScollerPlot from './FullWidthScollerPlot'
import BarChart from './BarChart'
import SortingTable from '../VehicleAnalysis/SortingTable'
import AvgRetailTable from './AvgRetailTable'
import TimeToSellTable from './TimeToSellTable'
import AppetiteIndex from './AppetiteIndex';

const barData1 = [
    { x: 'Jan', y: 11 },
    { x: 'Feb', y: 19 },
    { x: 'Mar', y: 20 },
    { x: 'Apr', y: 18 },
    { x: 'May', y: 23 },
    { x: 'Jun', y: 26 },
    { x: 'Jul', y: 19 },
    { x: 'Aug', y: 19 },
    { x: 'Sep', y: 22 },
    { x: 'Oct', y: 24 },
    { x: 'Nov', y: 28 },
    { x: 'Dec', y: 27 },
]
const TabContentDealerAnalysis = ({ isActive, dealerAnalysisData, numberFormatter }) => {
    const processMonthlyData = (data) => {
        if (!data || !Array.isArray(data)) {
            console.error("Invalid data format:", data);
            return [];
        }
        const validData = data.filter(d => d?.x);
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const parsedData = validData.map(d => {
            const monthIndex = parseInt(d.x.split("-")[0], 10) - 1;
            return {
                ...d,
                date: d3.timeParse("%m-%d")(d.x),
                month: monthNames[monthIndex]
            };
        });

        if (parsedData.length === 0) {
            console.warn("No valid data entries found.");
            return [];
        }
        const monthlyData = [];
        const seenMonths = new Set();

        parsedData.forEach(d => {
            if (!seenMonths.has(d.month)) {
                monthlyData.push({ x: d.month, y: d.y });
                seenMonths.add(d.month);
            }
        });
        const firstMonth = monthlyData[0]?.x;

        if (!firstMonth) {
            console.warn("No valid first month found.");
            return [];
        }
        const startIndex = monthNames.indexOf(firstMonth);
        const orderedMonths = [...monthNames.slice(startIndex), ...monthNames.slice(0, startIndex)];
        monthlyData.sort((a, b) => orderedMonths.indexOf(a.x) - orderedMonths.indexOf(b.x));

        return monthlyData;
    };
    const monthlyData = processMonthlyData(dealerAnalysisData?.["inventory_trend_plot"] ?? []);

    return (
        <>
            <div className='mt-0'>
                <AppetiteIndex dealerAnalysisData={dealerAnalysisData} numberFormatter={numberFormatter}/>
            </div>
            <div className='mt-4'>
                <div className='common-box-border'>
                    <div className='sm-title text-uppercase mb-3'>
                        DEALER'S INVENTORY
                        <div className="tooltip-container info-msg">
                            <img className="ico_info" src={getImages('red-ico-info.svg')} />
                            <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                        </div>
                    </div>
                    {dealerAnalysisData && 'current_inventory' in dealerAnalysisData && <AvgRetailTable
                        data={dealerAnalysisData['current_inventory']}
                        numberFormatter={numberFormatter} />}
                </div>
            </div>
            <div className='row gx-5 mt-4'>
                <div className='col-md-6'>
                    <div className='gray-box pe-2 h-380'>
                        <div className='sm-title text-uppercase mb-3'><img className='me-3' src={getImages('out.svg')} /> Last 10 <span className='text-lred'>Sold</span></div>
                        <div className='custom-table simple-table scrollbar-vertical'>
                            <div className='sv-head'>
                                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className='text-start' style={{ width: '60%' }}>Year Make Model Trim</th>
                                            <th style={{ width: '10%' }}>Miles</th>
                                            <th style={{ width: '20%' }}>Days on Lot</th>
                                            <th style={{ width: '10%' }}>Price</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className='sv-body'>
                                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        {dealerAnalysisData && 'recent_sold' in dealerAnalysisData && dealerAnalysisData['recent_sold'].map((v, i) => {
                                            return i < 10 ? <tr key={i}>
                                                <td className='text-start' style={{ width: '60%' }}>{v.year_is + " " + v.make_ss + " " + v.model_ss + " " + v.trim_ss}</td>
                                                <td style={{ width: '10%' }}>{numberFormatter(v.miles_fs)}</td>
                                                <td style={{ width: '20%' }}>{numberFormatter(v.dom_is)}</td>
                                                <td style={{ width: '10%' }}>{numberFormatter(v.price_fs, true)}</td>
                                            </tr> : <React.Fragment key={i} />;
                                        })}
                                        <tr>
                                            <td colSpan={4} className='pt-5'>
                                                <button className='red-transparent-btn w-206 text-uppercase'>View All</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='gray-box pe-2 h-380'>
                        <div className='sm-title text-uppercase mb-3'><img className='me-3' src={getImages('enter.svg')} /> Last 10 <span className='text-lred'>Purchased</span></div>
                        <div className='custom-table simple-table scrollbar-vertical'>
                            <div className='sv-head'>
                                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead>
                                        <tr>
                                            <th className='text-start' style={{ width: '60%' }}>Year Make Model Trim</th>
                                            <th style={{ width: '10%' }}>Miles</th>
                                            <th style={{ width: '20%' }}>Days on Lot</th>
                                            <th style={{ width: '10%' }}>Price</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                            <div className='sv-body'>
                                <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <tbody>
                                        {dealerAnalysisData && 'recent_bought' in dealerAnalysisData && dealerAnalysisData['recent_bought'].map((v, i) => {
                                            return i < 10 ? <tr key={i}>
                                                <td className='text-start' style={{ width: '60%' }}>{v.year_is + " " + v.make_ss + " " + v.model_ss + " " + v.trim_ss}</td>
                                                <td style={{ width: '10%' }}>{numberFormatter(v.miles_fs)}</td>
                                                <td style={{ width: '20%' }}>{numberFormatter(v.dom_is)}</td>
                                                <td style={{ width: '10%' }}>{numberFormatter(v.price_fs, true)}</td>
                                            </tr> : <React.Fragment key={i} />;
                                        })}
                                        <tr>
                                            <td colSpan={4} className='pt-5'>
                                                <button className='red-transparent-btn w-206 text-uppercase'>View All</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row g-5 mt-1'>
                <div className='col-md-6'>
                    <div className='common-box-border'>
                        <div className='sm-title text-uppercase mb-3'>
                            Top 5 Makes Sold
                            <div className="tooltip-container info-msg">
                                <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                            </div>
                        </div>
                        {dealerAnalysisData && 'makes_sold' in dealerAnalysisData && <BarChart width="100%"
                            isActive={isActive}
                            data={dealerAnalysisData['makes_sold']} />}
                    </div>
                </div>
                <div className='col-md-6'>
                    <div className='common-box-border'>
                        <div className='sm-title text-uppercase mb-3'>
                            Time to Sell
                            <div className="tooltip-container info-msg">
                                <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                            </div>
                        </div>
                        {dealerAnalysisData && 'time_to_sell' in dealerAnalysisData && <TimeToSellTable
                            data={dealerAnalysisData['time_to_sell']} />}
                    </div>
                </div>
            </div>
            <div className='row mt-5'>
                <div className='col-12'>
                    <div className='common-box-border'>
                        <div className='sm-title text-uppercase mb-5'>
                            TOTAL FLOORPLAN BY RETAIL PRICE
                            <div className="tooltip-container info-msg">
                                <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                            </div>
                        </div>
                        {dealerAnalysisData && 'inventory_trend_plot' in dealerAnalysisData && <FullWidthScollerPlot
                            data={dealerAnalysisData['inventory_trend_plot']} width="100%" height={300} isVisible={true} svgColor="rgb(229, 38, 64)"
                            xAxisColor="#fff"
                            yAxisColor="#fff"
                            numberFormatter={numberFormatter}
                        />}
                    </div>
                </div>
            </div>
        </>
    )
}

export default TabContentDealerAnalysis